/**
 * API base URL for all backend calls.
 * - Web (dev/prod): empty string — relative /api paths work via Vite proxy or co-located Express
 * - Mobile (Capacitor): set VITE_API_BASE_URL in .env.mobile to the Cloud Run URL
 */
export const API_BASE: string = import.meta.env.VITE_API_BASE_URL ?? '';
